<template>
  <v-main>
    <v-container
      fluid
      style="height: calc(100vh - 64px)"
    >
      <router-view v-slot="{ Component }">
        <v-scale-transition mode="out-in">
          <component :is="Component" />
        </v-scale-transition>
      </router-view>
    </v-container>
  </v-main>
</template>
